import React, { useEffect, useRef } from 'react';
import Slider from "react-slick";
import Image from "../../components/image";
import { Media, MediaContextProvider } from "../../media";
import { useGetCustomerListQuery } from '../../services';
import styles from './customer.module.scss';

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '10%'
}

const CustomerListDesktop = React.memo(({ activeIndex }) => {
  const sliderRef = useRef()
  const { data, isLoading, error } = useGetCustomerListQuery()

  useEffect(() => {
    if (sliderRef.current && sliderRef.current?.currentSlide !== activeIndex) {
      sliderRef.current.slickGoTo(activeIndex)
    }
  }, [activeIndex])

  if (error) {
    return <div>{error.message}</div>
  } else if (isLoading) {
    return <div className="text-center py-4">Loading ...</div>
  }

  return (
    <Slider ref={sliderRef} className="feedback-desktop" {...sliderSettings}>
      {data?.map((customer) => (
        <React.Fragment key={customer.id}>
          <div>
            <Image src={customer.thumbnail} alt={customer.name} className="img-slide" />
          </div>
          <div className="description">
            <div className="comment">
              <h2 className="text-menu-title mb-0">{customer.quote}</h2>
            </div>
            <div className="credit">
              <h3 className="text-caption mb-0">{customer.name}</h3>
              <p className="text-address">{customer.position}</p>
            </div>
          </div>
        </React.Fragment>
      ))}
    </Slider>
  )
})


const CustomerListMobile = React.memo(() => {
  const { data, isLoading, error } = useGetCustomerListQuery()

  if (error) {
    return <div>{error.message}</div>
  } else if (isLoading) {
    return <div className="text-center">Loading ...</div>
  }

  return (
    <Slider className="feedback-mobile" {...sliderSettings} arrows={false} centerPadding={'0%'}>
      {data?.map((customer) => (
        <React.Fragment key={customer.id}>
          <div className="description">
            <div className="comment">
              <p>{customer.quote}</p>
            </div>
            <div className="credit">
              <div className="image-cover">
                <Image src={customer.thumbnail} alt={customer.name} />
              </div>
              <div className="name">
                <h3 className="text-menu-title">{customer.name}</h3>
                <p className="text-address">{customer.position}</p>
              </div>
            </div>
          </div>
        </React.Fragment>
      ))}
    </Slider>
  )
})

export class CustomerSlide extends React.PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      activeIndex: 0
    }
  }

  render() {
    const { activeIndex } = this.state

    return (
      <div className={styles.customerReview}>
        <div className="container mt-5">
          <div className="row">

            <div className="col-md-3">
              <div className="filter">
                <h2 className="m-0">รีวิว</h2>
                <h6 className="m-0">จากผู้ใช้งาน Silverman</h6>
                <ul className="list-group list-unstyled">
                  <li className={activeIndex === 0 ? 'text-primary' : ''} onClick={() => this.setState({ activeIndex: 0 })}>
                    ความเห็นจากกรรมการ
                  </li>
                  <li className={activeIndex === 1 ? 'text-primary' : ''} onClick={() => this.setState({ activeIndex: 1 })}>
                    ความเห็นจากลูกบ้าน
                  </li>
                  <li className={activeIndex === 2 ? 'text-primary' : ''} onClick={() => this.setState({ activeIndex: 2 })}>
                    ความเห็นจากนิติบุคคล
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-9">
              <MediaContextProvider>
                <Media lessThan="md">
                  <CustomerListMobile />
                </Media>

                <Media greaterThanOrEqual="md">
                  <div className="d-block" style={{ paddingBottom: '5rem' }}>
                    <CustomerListDesktop activeIndex={activeIndex} />
                  </div>
                </Media>
              </MediaContextProvider>
            </div>

          </div>
        </div>
      </div>
    )
  }

}
